//Common service for dealing with small tables

app.factory(
    'StockingVisuelService', ['LocalStorage', 'Configuration', 'ApiService', 'Upload', '$rootScope', '$http', '$window', StockingVisuelService]
);

function StockingVisuelService(LocalStorage, Configuration, ApiService, UploadServcie, $rootScope, $http, $window) {
    self.GetIndexVisuel = GetIndexVisuel;
    self.Create = Create;
    self.Remove = Remove;
    self.Rename = Rename;
    self.ViewImage = ViewImage;
    self.ViewImageModal = ViewImageModal;
    self.Download = Download;
    self.Upload = Upload;
    self.UploadFilesForObject = UploadFilesForObject;
    self.DownloadAssociatedFile = DownloadAssociatedFile;
    self.SaveNotes = SaveNotes;

    function ViewImage(path, contentType) {
        return $http({
            method: 'GET',
            url: Configuration.api.url + '/api/StockingVisuelApi/ViewImage?path=' + path,
            params: {},
            responseType: 'arraybuffer'
        })
            .then(function (response) {
                var headers = response.headers();
                var filename = headers['x-filename'];
                var linkElement = document.createElement('a');
                try {
                    var blob = new Blob([response.data], { type: contentType });

                    if (window.navigator.msSaveOrOpenBlob) {
                        window.navigator.msSaveOrOpenBlob(blob, filename);
                    } else {
                        var url = window.URL.createObjectURL(blob);
                        linkElement.setAttribute('href', url);
                        if (contentType === headers["content-type"]) {
                            linkElement.setAttribute("download", filename);
                        }

                        linkElement.setAttribute('target', '_self');

                        var clickEvent = new MouseEvent("click", {
                            "view": window,
                            "bubbles": true,
                            "cancelable": false
                        });
                        linkElement.dispatchEvent(clickEvent);
                    }
                } catch (ex) {
                    console.log(ex);
                }
            });
    }




    function ViewImageModal(path, contentType) {
        return $http({
            method: 'GET',
            url: Configuration.api.url + '/api/StockingVisuelApi/ViewImage?path=' + path,
            params: {},
            responseType: 'arraybuffer'
        })
            .then(function (response) {
                let player = document.getElementById("blobviewer");

                var blob = new Blob([response.data], { type: "image/" + contentType });

                let videoUrl = window.URL.createObjectURL(blob);
                player.src = videoUrl;
            });
    }

    function Download(path, contentType) {
        return $http({
            method: 'GET',
            url: Configuration.api.url + '/api/StockingVisuelApi/Download?path=' + path,
            params: {},
            responseType: 'arraybuffer'
        }).then(function (response) {
            var headers = response.headers();
            var filename = headers['x-filename'];
            var linkElement = document.createElement('a');
            try {
                var blob = new Blob([response.data], { type: contentType });

                if (window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else {
                    var url = window.URL.createObjectURL(blob);
                    linkElement.setAttribute('href', url);
                    if (contentType === headers["content-type"]) {
                        linkElement.setAttribute("download", filename);
                    }

                    linkElement.setAttribute('target', '_self');

                    var clickEvent = new MouseEvent("click", {
                        "view": window,
                        "bubbles": true,
                        "cancelable": false
                    });
                    linkElement.dispatchEvent(clickEvent);
                }
            } catch (ex) {
                console.log(ex);
            }
        });
    }

    function DownloadAssociatedFile(path, contentType) {
        return $http({
            method: 'GET',
            url: Configuration.api.url + '/api/StockingVisuelApi/DownloadAssociatedFile?path=' + path,
            params: { name: name },
            responseType: 'arraybuffer'
        }).then(function (response) {
            var headers = response.headers();
            var filename = headers['x-filename'];
            var linkElement = document.createElement('a');
            try {
                var blob = new Blob([response.data], { type: contentType });
                if (window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else {
                    var url = window.URL.createObjectURL(blob);
                    linkElement.setAttribute('href', url);
                    linkElement.setAttribute("download", filename);
                    linkElement.setAttribute('target', '_self');
                    linkElement.click();
                }
            } catch (ex) {
                console.log(ex);
            }
        });
    }

    function Upload(path, files) {
        var request = UploadServcie.upload({
            url: Configuration.api.url + "/api/StockingVisuelApi/Upload?path=" + path,
            data: {
                files: files
            }
        });

        return request;
    }

    function UploadFilesForObject(files) {
        var request = UploadServcie.upload({
            url: Configuration.api.url + "/api/StockingVisuelApi/UploadFilesForObject",
            data: {
                files: files
            }
        });

        return request;
    }

    function GetIndexVisuel(path, search, sort, reverse) {
        var request = ApiService.get("/api/StockingVisuelApi/GetIndex?path=" + path + "&search=" + search + "&sort=" + sort + "&reverse=" + reverse);
        return request;
    }

    function Create(path) {
        var request = ApiService.get("/api/StockingVisuelApi/Create?path=" + path);
        return request;
    }

    function Remove(path) {
        var request = ApiService.get("/api/StockingVisuelApi/Remove?path=" + path);
        return request;
    }

    function Rename(oldvalue, newvalue) {
        var request = ApiService.get("/api/StockingVisuelApi/Rename?oldvalue=" + oldvalue + "&newvalue=" + newvalue);
        return request;
    }

    function SaveNotes(item) {
        var request = ApiService.post("/api/StockingVisuelApi/SaveNotes", item);

        return request;
    }

    return self;
}